import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import type { Locale } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

dayjs.extend(utc)
dayjs.extend(advancedFormat)

type DayJsInputTime = Parameters<typeof dayjs>[0]
type FormatTimeFn = (time: DayJsInputTime) => string
type FormatTimeLocaleFn = (time: DayJsInputTime, locale: Locale) => string

export const formatTime = (time: DayJsInputTime, format: string): string => dayjs(time).utc(false).format(format)
export const formatTimeLocale = (time: DayJsInputTime, format: string, locale: Locale, timezone = 'UTC'): string =>
  formatInTimeZone(dayjs(time).toDate(), timezone, format, { locale })

export const formatTimestamp: FormatTimeFn = (time) => formatTime(time, 'MMM Do hh:mm A UTC')
export const formatTimestampLocale: FormatTimeLocaleFn = (time, locale, timezone = 'UTC') =>
  formatTimeLocale(time, 'MMM do hh:mm aa', locale, timezone)
export const formatShortDate: FormatTimeFn = (time) => formatTime(time, 'MMM Do')
export const formatMonth: FormatTimeFn = (time) => formatTime(time, 'MMM')
export const formatTimestampLong: FormatTimeFn = (time) => formatTime(time, 'MMM-DD-YYYY HH:mm UTC')
